import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(`[ErrorBoundary: ${this.props.label || 'unknown'}]`, error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-fallback">
          <div className="error-boundary-icon">⚠</div>
          <p className="error-boundary-title">
            {this.props.label ? `${this.props.label} ran into a problem.` : 'Something went wrong.'}
          </p>
          <p className="error-boundary-hint">This is usually caused by unexpected data from the server.</p>
          <button
            className="error-boundary-btn"
            onClick={() => this.setState({ hasError: false })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
